(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["calorieen-calculator"] && !Shopify.designMode) return;
  try {
    class CalorieenCalculator {
    constructor(container) {
      this.container = container;
      this.form = container.querySelector('[data-calculator-form]');
      this.results = container.querySelector('[data-calculator-results]');
      
      this.init();
    }

    init() {
      this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }

    handleSubmit(e) {
      e.preventDefault();
      
      const formData = new FormData(this.form);
      const data = {
        geslacht: formData.get('geslacht'),
        leeftijd: parseInt(formData.get('leeftijd')),
        lengte: parseInt(formData.get('lengte')),
        gewicht: parseFloat(formData.get('gewicht')),
        activiteit: parseFloat(formData.get('activiteit')),
        doel: formData.get('doel')
      };

      // Valideer input
      if (!this.validate(data)) {
        return;
      }

      // Bereken resultaten
      const results = this.calculate(data);

      if (typeof window.syncNutritionCalculatorToKlaviyo === 'function') {
        window.syncNutritionCalculatorToKlaviyo({
          calculatorType: 'calorie',
          geslacht: data.geslacht,
          leeftijd: data.leeftijd,
          lengte: data.lengte,
          gewicht: data.gewicht,
          activiteitFactor: data.activiteit,
          doel: data.doel,
          calorieTarget: results.goal,
        });
      }

      // Toon resultaten
      this.showResults(results, data.doel);
    }

    validate(data) {
      if (!data.geslacht || !data.leeftijd || !data.lengte || !data.gewicht || !data.activiteit || !data.doel) {
        alert('Vul alle velden in om je caloriebehoefte te berekenen.');
        return false;
      }
      return true;
    }

    calculate(data) {
      // BMR berekening (Mifflin-St Jeor Equation)
      let bmr;
      if (data.geslacht === 'man') {
        bmr = 10 * data.gewicht + 6.25 * data.lengte - 5 * data.leeftijd + 5;
      } else {
        bmr = 10 * data.gewicht + 6.25 * data.lengte - 5 * data.leeftijd - 161;
      }

      // TDEE = BMR * activiteitsfactor
      const tdee = Math.round(bmr * data.activiteit);

      // Doel aanpassing
      let goalCalories = tdee;
      let goalText = 'Voor gewicht behouden';
      
      if (data.doel === 'afvallen') {
        goalCalories = Math.round(tdee * 0.85); // 15% tekort
        goalText = 'Voor afvallen (15% tekort)';
      } else if (data.doel === 'aankomen') {
        goalCalories = Math.round(tdee * 1.15); // 15% surplus
        goalText = 'Voor aankomen (15% surplus)';
      }

      return {
        bmr: Math.round(bmr),
        tdee: tdee,
        goal: goalCalories,
        goalText: goalText
      };
    }

    animateValue(element, start, end, duration) {
      const startTime = performance.now();
      const difference = end - start;
      
      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        // Easing functie voor soepele animatie
        const easeOutQuart = 1 - Math.pow(1 - progress, 4);
        const current = Math.round(start + (difference * easeOutQuart));
        
        element.textContent = current.toLocaleString('nl-NL');
        
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          element.textContent = end.toLocaleString('nl-NL');
        }
      };
      
      requestAnimationFrame(animate);
    }

    showResults(results, doel) {
      // Scroll naar resultaten
      this.results.style.display = 'flex';
      this.results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      
      // Focus op resultaten voor accessibility
      const resultsTitle = this.results.querySelector('.calorieen-calculator__results-title');
      if (resultsTitle) {
        resultsTitle.setAttribute('tabindex', '-1');
        resultsTitle.focus();
      }

      // Update goal text eerst
      this.container.querySelector('[data-result-goal-text]').textContent = results.goalText;

      // Animeer de kcal waarden met count-up effect
      const bmrElement = this.container.querySelector('[data-result-bmr]');
      const tdeeElement = this.container.querySelector('[data-result-tdee]');
      const goalElement = this.container.querySelector('[data-result-goal]');

      // Start animaties met kleine delay tussen elk getal voor visueel effect
      setTimeout(() => {
        this.animateValue(bmrElement, 0, results.bmr, 1200);
      }, 100);

      setTimeout(() => {
        this.animateValue(tdeeElement, 0, results.tdee, 1200);
      }, 300);

      setTimeout(() => {
        this.animateValue(goalElement, 0, results.goal, 1200);
      }, 500);
    }

  }

  function initCalorieCalculators() {
    const calculators = document.querySelectorAll('.calorieen-calculator[data-calculator]');
    calculators.forEach((calculator) => {
      if (!calculator.dataset.initialized) {
        calculator.dataset.initialized = 'true';
        new CalorieenCalculator(calculator);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCalorieCalculators);
  } else {
    initCalorieCalculators();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["protein-calculator"] && !Shopify.designMode) return;
  try {
    class ProteinCalculator {
    constructor(container) {
      this.container = container;
      this.form = container.querySelector('[data-calculator-form]');
      this.results = container.querySelector('[data-calculator-results]');
      
      this.init();
    }

    init() {
      this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }

    handleSubmit(e) {
      e.preventDefault();
      
      const formData = new FormData(this.form);
      const data = {
        geslacht: formData.get('geslacht'),
        gewicht: parseFloat(formData.get('gewicht')),
        activiteit: formData.get('activiteit')
      };

      // Valideer input
      if (!this.validate(data)) {
        return;
      }

      // Bereken resultaten
      const results = this.calculate(data);

      if (typeof window.syncNutritionCalculatorToKlaviyo === 'function') {
        window.syncNutritionCalculatorToKlaviyo({
          calculatorType: 'protein',
          geslacht: data.geslacht,
          gewicht: data.gewicht,
          activiteitKey: data.activiteit,
          proteinDailyMin: results.dailyMin,
          proteinDailyMax: results.dailyMax,
        });
      }

      // Toon resultaten
      this.showResults(results);
    }

    validate(data) {
      if (!data.geslacht || !data.gewicht || !data.activiteit) {
        alert('Vul alle velden in om je eiwitbehoefte te berekenen.');
        return false;
      }
      return true;
    }

    calculate(data) {
      // Basis eiwitbehoefte: 0.8g/kg (RDA minimum)
      const baseProtein = 0.8 * data.gewicht;
      
      // Activiteitsniveau aanpassingen (g/kg)
      let activityMultiplier;
      let activityRange;
      
      switch(data.activiteit) {
        case 'weinig':
          activityRange = { min: 0.8, max: 1.2 };
          break;
        case 'licht':
          activityRange = { min: 1.4, max: 1.6 };
          break;
        case 'matig':
          activityRange = { min: 1.6, max: 2.0 };
          break;
        case 'zeer':
          activityRange = { min: 1.8, max: 2.2 };
          break;
        case 'extreem':
          activityRange = { min: 2.0, max: 2.2 };
          break;
        default:
          activityRange = { min: 0.8, max: 1.2 };
      }
      
      // Bereken eiwitbehoeften als bereik
      const dailyMin = Math.round(activityRange.min * data.gewicht);
      const dailyMax = Math.round(activityRange.max * data.gewicht);
      
      // Bereken per maaltijd (aannemend 3 maaltijden per dag)
      const mealsPerDay = 3;
      const mealMin = Math.round(dailyMin / mealsPerDay);
      const mealMax = Math.round(dailyMax / mealsPerDay);
      
      return {
        dailyMin: dailyMin,
        dailyMax: dailyMax,
        mealMin: mealMin,
        mealMax: mealMax
      };
    }

    animateValue(element, start, end, duration) {
      // Als start "--" is, begin met 0
      const startValue = start === '--' || isNaN(start) ? 0 : start;
      const startTime = performance.now();
      const difference = end - startValue;
      
      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        // Easing functie voor soepele animatie
        const easeOutQuart = 1 - Math.pow(1 - progress, 4);
        const current = Math.round(startValue + (difference * easeOutQuart));
        
        element.textContent = current.toLocaleString('nl-NL');
        
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          element.textContent = end.toLocaleString('nl-NL');
        }
      };
      
      requestAnimationFrame(animate);
    }

    showResults(results) {
      // Focus op resultaten voor accessibility
      const resultsTitle = this.results.querySelector('.protein-calculator__results-title');
      if (resultsTitle) {
        resultsTitle.setAttribute('tabindex', '-1');
        requestAnimationFrame(() => {
          resultsTitle.focus();
        });
      }

      // Animeer de waarden met count-up effect
      const dailyMinElement = this.container.querySelector('[data-result-daily-min]');
      const dailyMaxElement = this.container.querySelector('[data-result-daily-max]');
      const mealMinElement = this.container.querySelector('[data-result-meal-min]');
      const mealMaxElement = this.container.querySelector('[data-result-meal-max]');

      // Verwijder placeholder attributen en start animaties
      const removePlaceholder = (element) => {
        element.removeAttribute('data-placeholder');
      };

      // Start animaties voor dagelijkse waarden
      setTimeout(() => {
        removePlaceholder(dailyMinElement);
        const currentMin = dailyMinElement.textContent === '--' ? 0 : parseInt(dailyMinElement.textContent) || 0;
        this.animateValue(dailyMinElement, currentMin, results.dailyMin, 1200);
      }, 100);

      setTimeout(() => {
        removePlaceholder(dailyMaxElement);
        const currentMax = dailyMaxElement.textContent === '--' ? 0 : parseInt(dailyMaxElement.textContent) || 0;
        this.animateValue(dailyMaxElement, currentMax, results.dailyMax, 1200);
      }, 300);

      // Start animaties voor per maaltijd waarden
      setTimeout(() => {
        removePlaceholder(mealMinElement);
        const currentMealMin = mealMinElement.textContent === '--' ? 0 : parseInt(mealMinElement.textContent) || 0;
        this.animateValue(mealMinElement, currentMealMin, results.mealMin, 1200);
      }, 500);

      setTimeout(() => {
        removePlaceholder(mealMaxElement);
        const currentMealMax = mealMaxElement.textContent === '--' ? 0 : parseInt(mealMaxElement.textContent) || 0;
        this.animateValue(mealMaxElement, currentMealMax, results.mealMax, 1200);
      }, 700);
    }

  }

  // Initialiseer calculator wanneer DOM klaar is
  function initProteinCalculators() {
    const calculators = document.querySelectorAll('.protein-calculator[data-calculator]');
    calculators.forEach(calculator => {
      if (!calculator.dataset.initialized) {
        calculator.dataset.initialized = 'true';
        new ProteinCalculator(calculator);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProteinCalculators);
  } else {
    initProteinCalculators();
  }
  } catch(e) { console.error(e); }
})();

})();
